import { createGlobalStyle } from 'styled-components'

export const GlobalStyled = createGlobalStyle`
  *{
    font-family: 'Vazir-light', sans-serif !important;
    box-sizing: border-box;
  }


  code {
    font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New',
      monospace;
  }

  a{
    color: #1890ff;
    cursor: pointer;
    outline: none;
    text-decoration: none;
    transition: color .3s;
  }
  
  body{
    padding: 0 !important;
    margin : 0 !important;
    overflow-y: auto !important;
  }
  

  .iconDetail{
    justify-content: center !important;
    display: flex !important;
    align-items: center !important;
    margin: auto !important;
    height: 90vh !important;
    font-size: 1.5rem !important;
  }

  textarea{
    width: 100%;
    resize: none;
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 8px;
  }

  .noselect {
      -webkit-touch-callout: none; 
      -webkit-user-select: none; 
      -khtml-user-select: none; 
      -moz-user-select: none; 
      -ms-user-select: none;
      user-select: none; 
}

  .MuiMenuItem-root{
    padding: 2px !important;
    font-size: 0.9rem !important;
  }

  .muirtl-oqt7a2-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper{
    max-height: calc(40% - 32px) !important;
  }


 .MuiInputBase-input{
  padding: 6.5px 14px !important;
  &.Mui-disabled{
    -webkit-text-fill-color:#2d2d2d !important;
    background-color: #eee;
  }
}
.MuiInputLabel-sizeSmall,.MuiInputBase-sizeSmall{
  font-size: 0.9rem !important; 
  &.Mui-disabled{
    color: #6c6c6c  !important;
  }
}
    



  .MuiInputBase-root {
      /* min-height: 30px !important;*/
      border-radius: 15px !important;
      overflow: hidden !important;
     /* font-size: 0.5rem !important;*/
     
  }

  .MuiFormControl-root{
    border-radius: 15px !important;
     background-color: transparent !important;
  }

  .MuiSvgIcon-root {
    font-size: 1.2rem !important;
  }

  .MenuUtilsVisitQueue .MuiList-root{
    width: 180px !important;
    padding: 3px 7px;
  }

  .MenuUtilsVisitQueue .MuiList-root .MuiButtonBase-root{
    margin-bottom:4px;
     border-bottom: 1px solid #f5f5f7;
     padding: 10px !important;
  }
  .MenuUtilsVisitQueue .MuiList-root .MuiButtonBase-root:last-child{
    margin-bottom:0;
     border-bottom:none;
  }

  .popoverElectronicPrescriptionColName .MuiPaper-root{
    padding: 7px !important;
    background: rgba(0,0,0,0.8) !important;
    color: #fff !important;
    font-size: 0.9rem !important;
  }
  
  .btnDropDown .MuiPaper-root{
    width: 200px;
     padding: 0 10px;
     box-shadow: 1px 1px 5px 1px rgb(229, 231, 235);
  }

  .btnDropDown .MuiPaper-root .MuiButtonBase-root{
   margin-bottom: 10px;
    border-bottom: 1px solid rgb(249, 251, 255);
     border-radius: 5px;
     /* padding: 3px 30px; */

  }

  /* .muirtl-6hp17o-MuiList-root-MuiMenu-list */
  .btnDropDown .MuiPaper-root .MuiButtonBase-root:last-child{
   margin-bottom: 0;
  }
   .btnDropDown.profileSubMenu {
      left: 200px;
       background: transparent !important;
  
  } 
  


 .muirtl-oqt7a2-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper{
    overflow:  visible !important;
     height: 100% auto;
  }
  .muirtl-oqt7a2-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper {
  max-height: calc(100% - 32px) !important;
}

.MuiAutocomplete-paper{
  font-size: 0.9rem !important;
}

  
  .referenceDropDown .MuiPaper-root{
    width: 250px;
    height: auto !important;
    /*min-height: 430px;*/
     padding: 0 10px;
     box-shadow: 1px 1px 5px 1px rgb(229, 231, 235);
  }

  .referenceDropDown .MuiPaper-root .MuiButtonBase-root{
   margin-bottom: 10px;
    border-bottom: 1px solid rgb(249, 251, 255);
     border-radius: 5px;
     padding-right:  30px;

  }

  
  .visitDrawer .MuiPaper-root{
    background: #f9fbff !important;
    width: 100% !important;
  }


.cursor-pointer{
  cursor:pinter
}

.MuiAutocomplete-inputRoot {
  padding-top:0 !important;
  padding-bottom:0 !important;
}

.allergy_alert{
  position: relative;
  &::after {
    content:'!';
    position: absolute;
    bottom: 13px;
    left: 0;
    display:block;
    width:15px;
    height:15px;
    background-color:red;
    border-radius: 50%;
    text-align: center;
    font-size: 11px;
    color: white;
    animation:blink 0.8s infinite forwards ;
  }
}
.disease_alert{
  position: relative;
  &::after {
    content:'!';
    position: absolute;
    bottom: 13px;
    left: 7px;
    display:block;
    width:15px;
    height:15px;
    background-color:orange;
    border-radius: 50%;
    text-align: center;
    font-size: 11px;
    color: white;
    animation:blink 1.3s infinite forwards ;
  }
}

.confirm_icon{
  margin-right: auto;
  font-size: 2rem !important;
  stroke: #6c6c6c;
  stroke-dasharray: 70;
  stroke-dashoffset: 70;
  animation:warningIconDrow 1s forwards,warningIconScale 1s 1s  forwards  ;
 
}

.select-styles{

  max-height: 50vh !important;
  padding: 5px;
  overflow: hidden auto !important;
}


@keyframes warningIconDrow{
  to{
    stroke-dashoffset: 0;
  }
}

@keyframes warningIconScale{
 0%{
    transform: scale(1);
  }
  50%{
    transform: scale(1.2);
  }
}

@keyframes blink {
  0% {
   opacity:1;
  }
 50%{
  opacity:0;
  }
}
 
`
